<img [src]="path" />
